module.exports = __webpack_public_path__ + "static/RLG-logo-18396db615cfa89755e1b7b8b484fd23.png";